import { CloudUploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Flex, Popconfirm } from "antd";

import { PrimaryText } from "@/components/Typography/Styled";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import useAsyncAction from "@/hooks/useAsyncAction";
import { useQueueInfo } from "@/hooks/useQueueInfo";
import { useResetApp } from "@/hooks/useResetApp";
import { StyledInfoBlock } from "@/pages/Profile/MainInformation/components/UserInfo/Styled";
import { StyledUserCard } from "@/pages/Profile/MainInformation/Styled";
import { saveProgressToServerThunk } from "@/store/thunks";

import { StyledButton } from "./Styled";

export const ProgressSync = () => {
    const { offlineMode } = useAppSelector((s) => s.offline);

    const { isRunning: isRunningQueue } = useQueueInfo();

    const dispatch = useAppDispatch();

    const [handleSaveProgress, saveProgressLoading] = useAsyncAction(
        async () => {
            await dispatch(saveProgressToServerThunk());
        },
    );

    const { handleReset, resetLoading } = useResetApp();

    const disableAction = offlineMode || isRunningQueue;

    return (
        <StyledUserCard>
            <StyledInfoBlock>
                <PrimaryText fontSize={16} fontWeight="500">
                    Синхронізація даних
                </PrimaryText>

                <Flex vertical gap={12}>
                    <StyledButton
                        icon={<CloudUploadOutlined />}
                        type="primary"
                        onClick={handleSaveProgress}
                        disabled={disableAction}
                        style={{ width: "100%" }}
                        size="large"
                        loading={saveProgressLoading}
                    >
                        Відправити на сервер
                    </StyledButton>

                    <Popconfirm
                        title="Ви впевнені що хочете скинути кеш?"
                        onConfirm={handleReset}
                        disabled={offlineMode}
                        okText="Так"
                        cancelText="Ні"
                    >
                        <StyledButton
                            icon={<DownloadOutlined />}
                            type="primary"
                            disabled={disableAction}
                            loading={resetLoading}
                            style={{ width: "100%" }}
                            size="large"
                        >
                            Завантажити на пристрій
                        </StyledButton>
                    </Popconfirm>
                </Flex>
            </StyledInfoBlock>
        </StyledUserCard>
    );
};
